import { call, put, takeLatest } from "redux-saga/effects";
import {
  submitDsaForm,
  submitDsaFormSuccess,
  submitDsaFormFailure,
} from "../slices/dsaSlice";

const API_URL = process.env.REACT_APP_API_URL;

const postDsaFormAPI = async (formData) => {
  const res = await fetch(`${API_URL}/v1/partner/register`, {
    method: "POST",
    body: formData, // No headers needed for FormData
  });

  const result = await res.json();
  
  // ✅ Handle backend validation errors properly
  if (!res.ok || result.status === false) {
    // If backend sends errors object, throw it
    if (result.errors) {
      throw result.errors;
    }
    // Otherwise throw the message
    throw new Error(result.message || "Submission failed");
  }
  
  return result;
};

function* handleSubmitDsaForm(action) {
  try {
    yield call(postDsaFormAPI, action.payload);
    yield put(submitDsaFormSuccess());
  } catch (error) {
    // ✅ Pass the entire error object (could be errors object or Error instance)
    if (typeof error === 'object' && !(error instanceof Error)) {
      // Backend validation errors object
      yield put(submitDsaFormFailure(error));
    } else {
      // Regular error message
      yield put(submitDsaFormFailure(error.message || "Submission failed"));
    }
  }
}

export function* watchDsaSaga() {
  yield takeLatest(submitDsaForm.type, handleSubmitDsaForm);
}
